import { Config } from "../Config.js";
import { ENVIRONMENT } from "../types/EnvironmentType.js";
/**
 * Determines whether the current environment is the production environment or the hipaa environment.
 *
 * @return {boolean}
 */ export var isClientEnvironment = function() {
    return Config.env === ENVIRONMENT.production || Config.env === ENVIRONMENT.hipaa;
};

//# sourceMappingURL=isClientEnvironment.js.map